import { render, staticRenderFns } from "./DetailRelocatemodal.vue?vue&type=template&id=29b3ec87"
import script from "./DetailRelocatemodal.vue?vue&type=script&lang=js"
export * from "./DetailRelocatemodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports